import { useCallback } from 'react';

const useSessionStorage = () => {
  const getSessionStorage = useCallback((key, defaultValue) => {
    const stored = window && window.sessionStorage.getItem(key);
    if (stored) {
      return JSON.parse(stored);
    }
    return defaultValue;
  }, []);

  const saveToSessionStorage = useCallback((key, value) => {
    window && window.sessionStorage.setItem(key, JSON.stringify(value));
  }, []);

  return [getSessionStorage, saveToSessionStorage];
};

export default useSessionStorage;
